//Dependencies
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
//Pages
import NotFoundPage from './assets/modules/pages/NotFoundPage';
import InfoPage from './assets/modules/pages/InfoPage';
import Calculadoras from './assets/modules/pages/calculadoras';
import Vigas from './assets/modules/pages/vigashormigon';
import Columnas from './assets/modules/pages/columnashormigon';
import Losas from './assets/modules/pages/losasmacizashormigon';
import Main from './assets/modules/pages/predimensionamiento';
import Contrapisos from './assets/modules/pages/contrapisos';
import MetalicasSencillas from './assets/modules/pages/metalicassencillas';
import Plantilla from './assets/modules/pages/plantilla';
import WallCalculator from './assets/modules/pages/wallCalculator';
import DrywallCalculator from './assets/modules/pages/drywallCalculator';
import Avaluos from './assets/modules/pages/avaluos';
import KitchenDesigner from './assets/modules/pages/kitchenDesigner';
import Contrapiso from './assets/modules/pages/contrapiso';
import BrickWall from './assets/modules/pages/brickWall';
import TileFloor from './assets/modules/pages/tileFloor';
import PoolCalculator from './assets/modules/pages/poolCalculator';
import Wall_Brick_Clay from './assets/modules/pages/wall_brick_clay';
import Wall_Block_Mortar from './assets/modules/pages/wall_block_mortar';
import Wall_Boonker from './assets/modules/pages/wall_boonker';
import Wall_Brick_Clay_Hole from './assets/modules/pages/wall_brick_clay_holes';
import TechosEternit from './assets/modules/pages/techoseternit';
import Dosificador from './assets/modules/pages/dosificador';
import Profiles from './assets/modules/pages/profiles';
import BrickWallPage from './assets/modules/pages/wallholes';

import Apus from './assets/modules/pages/apusModificado';
import Apus2 from './assets/modules/pages/apus2';
import MaterialsViewer from './assets/modules/pages/materials';
import MaterialsViewer2 from './assets/modules/pages/materials2';

import Kubiroom from './assets/modules/pages/kubiroom';
import Pbr from './assets/modules/pages/pbr';
import Perspective from './assets/modules/pages/perspective';
import IFCLoad from './assets/modules/pages/ifc';

//Routers
import MainRouter from './assets/modules/routers/MainRouter';
import PortfolioRouter from './assets/modules/routers/PortfolioRouter';
//CSS
import './assets/css/input.css';
import './assets/css/custom.css';
import 'leaflet/dist/leaflet.css';
import 'antd/dist/antd.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          exact
          path    = '/404'
          element = {<NotFoundPage />}
        />

        <Route
          exact
          path    = '/info'
          element = {<InfoPage />}
        />        

        <Route
          exact
          path    = '/perspectiva'
          element = {<Perspective />}
        />
      
        <Route
          exact
          path    = '/pbr'
          element = {<Pbr />}
        />

        <Route
          exact
          path    = '/kubiroom'
          element = {<Kubiroom />}
        />

        <Route
          exact
          path    = '/wallholes'
          element = {<BrickWallPage />}
        />

        <Route
          exact
          path    = '/perfiles'
          element = {<Profiles />}
        />

        <Route
          exact
          path    = '/dosificador'
          element = {<Dosificador />}
        />

        <Route
          exact
          path    = '/techoseternit'
          element = {<TechosEternit />}
        />

        <Route
          exact
          path    = '/piscinas'
          element = {<PoolCalculator />}
        />

        <Route
          exact
          path    = '/piso_ceramica'
          element = {<TileFloor />}
        />

        <Route
          exact
          path    = '/boonker' 
          element = {<Wall_Boonker />}
        />

        <Route
          exact
          path    = '/pared_de_ladrillo_con_aberturas' 
          element = {<Wall_Brick_Clay_Hole />}
        />

        <Route
          exact
          path    = '/pared_de_ladrillo' 
          element = {<Wall_Brick_Clay />}
        />

         <Route
          exact
          path    = '/pared_de_bloque' 
          element = {<Wall_Block_Mortar />}
        />

        <Route
          exact
          path    = '/pared_ladrillo'
          element = {<BrickWall />}
        />

        <Route
          exact
          path    = '/kitchenDesigner'
          element = {<KitchenDesigner />}
        />

        <Route
          exact
          path    = '/contrapiso'
          element = {<Contrapiso />}
        />


        <Route
          exact
          path    = '/plantilla'
          element = {<Plantilla />}
        />

        <Route
          exact
          path    = '/calculadoras'
          element = {<Calculadoras />}
        />        

        <Route
          exact
          path    = '/columnas'
          element = {<Columnas />}
        />

        <Route
          exact
          path    = '/vigasrectangulareshormigon'
          element = {<Vigas />}
        />

        <Route
          exact
          path    = '/calculoparedes'
          element = {<WallCalculator />}
        />

        <Route
          exact
          path    = '/calculogypsum'
          element = {<DrywallCalculator />}
        />

        <Route
          exact
          path    = '/materiales'
          element = {<MaterialsViewer />}
        />

        <Route
          exact
          path    = '/materiales2'
          element = {<MaterialsViewer2 />}
        />        

        <Route
          exact
          path    = '/apus2'
          element = {<Apus2 />}
        />

        <Route
          exact
          path    = '/apus'
          element = {<Apus />}
        />

        <Route
          exact
          path    = '/avaluos'
          element = {<Avaluos />}
        />

        <Route
          exact
          path    = '/losasmacizashormigon'
          element = {<Losas />}
        />

        <Route
          exact
          path    = '/contrapisos'
          element = {<Contrapisos />}
        />

        <Route
          exact
          path    = '/predimensionamientohormigon'
          element = {<Main />}
        />

        <Route
          exact
          path    = '/metalicassencillas'
          element = {<MetalicasSencillas />}
        />

        <Route
          exact
          path    = '/ifcload'
          element = {<IFCLoad />}
        />

        <Route
          exact
          path    = '/'
          element = {<MainRouter />}
        />

        <Route
          exact
          path    = '/:id'
          element = {<PortfolioRouter />}
        />
        
        <Route 
          path = "*" 
          component = 
          {
            () => <NotFoundPage/>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;